import React, { useState, useEffect } from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import { BsPeopleFill, BsShieldFillCheck } from "react-icons/bs";
// import { HiStatusOnline } from "react-icons/hi";
import { BsFillPatchCheckFill, BsChatHeart } from "react-icons/bs";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import { FaCrown } from 'react-icons/fa';
import axios from 'axios';
import key from '../../key';
import { dobToAge } from '../../utilities/utilities';
import { useSelector } from 'react-redux';
import { Link,useNavigate } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { useDispatch } from 'react-redux';
import { addLikes } from '../../Redux/features/User/userSlice';
import { useCookies } from 'react-cookie';
import MatchContact from './MatchContact';

function MatchCard({ match }) {
    const [loading, setLoading] = useState(true)
    const [showPhoto, setShowPhoto] = useState("show")
    const [showBadge, setShowBadge] = useState(false)
    const [isConnected, setIsConnected] = useState(false)
    const [db, setDb] = useState()
    const [data, setData] = useState()
    const { user } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${key}/api/user/get-profile/${match?.userId}`, {
                headers: {
                    "x-auth-token": cookies['x-auth-token'],
                },
            });
            setIsConnected(result.data.isConnected)
            setData(result.data.user);

            if (result.data.user?.privacy.photo === "hide") {
                setShowPhoto("hide")
            } else if (result.data.user?.privacy.photo === "like" && !isConnected) {
                setShowPhoto("like")
            } else if (result.data.user?.privacy.photo === "premium" && user.userStatus.membership.membershipType === "Free") {
                setShowPhoto("premium")
            } else if (result.data.user?.privacy.photo === "likeAndPremium" && ((user.userStatus.membership.membershipType === "Free") || isConnected)) {
                setShowPhoto("premium")
            } else if (result.data.user?.privacy.photo === "likeAndPremium" && ((user.userStatus.membership.membershipType !== "Free") || !isConnected)) {
                setShowPhoto("like")
            }

        };
        fetchData();
        //eslint-disable-next-line
    }, []);

    setTimeout(() => {
        const getAge = () => {
            if (data?.personalDetails?.dob) {
                setDb(dobToAge(data?.personalDetails?.dob))
            }
        }
        getAge()
        if (data?.userStatus?.membership?.membershipType !== "Free") {
            setShowBadge(true)
        }
        setLoading(false)
    }, 500)

    const handleConnect = async (id) => {
        setLoading(true)
        const data = {
            id: {
                userId: id
            },
            header: cookies['x-auth-token']
        }
        dispatch(addLikes(data))
        setIsConnected(true)
        setLoading(false)
    }
    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                <ul>
                    {match.points.categories.age && <li ><BsFillPatchCheckFill className='text-success' />Matches your Age Preference </li>}
                    {match.points.categories.height && <li ><BsFillPatchCheckFill className='text-success' />Matches your Height Preference </li>}
                    {match.points.categories.maritalStatus && <li ><BsFillPatchCheckFill className='text-success' />Matches your Marital Status Preference </li>}
                    {match.points.categories.religion && <li ><BsFillPatchCheckFill className='text-success' />Matches your Religion Preference </li>}
                    {match.points.categories.motherTongue && <li ><BsFillPatchCheckFill className='text-success' />Matches your Mother Tounge Preference </li>}
                    {match.points.categories.community && <li ><BsFillPatchCheckFill className='text-success' />Matches your Community Preference </li>}
                    {match.points.categories.countryLiving && <li ><BsFillPatchCheckFill className='text-success' />Matches your Country Living In Preference </li>}
                    {match.points.categories.cityLiving && <li ><BsFillPatchCheckFill className='text-success' />Matches your City Living In Preference </li>}
                    {match.points.categories.grewUpIn && <li ><BsFillPatchCheckFill className='text-success' />Matches your Country Grew up In Preference </li>}
                    {match.points.categories.qualification && <li ><BsFillPatchCheckFill className='text-success' />Matches your Education Preference </li>}
                    {match.points.categories.workingWith && <li ><BsFillPatchCheckFill className='text-success' />Matches your Working Preference </li>}
                    {match.points.categories.occupation && <li ><BsFillPatchCheckFill className='text-success' />Matches your Occupation Preference </li>}
                    {match.points.categories.annualIncome && <li ><BsFillPatchCheckFill className='text-success' />Matches your Annual Income Preference </li>}
                    {match.points.categories.diet && <li ><BsFillPatchCheckFill className='text-success' />Matches your Diet Preference </li>}
                </ul>
            </Popover.Body>
        </Popover>
    );

    return (
        <>
            {loading ? <div className="loading-spinner"><PulseLoader size={50} color="#fa585b" /></div> :
                <div className="list-match-card">
                    <div className="match-photo">
                        <div className="list-image-container">
                            {showPhoto === "premium" && <div className="image-overlay">
                            <Image onClick={()=>navigate(`/view-match/${match?.userId}`)} fluid={true} src={`${key}/images/${data?.photos[0]?.url}`} alt="photo" />
                                <Link to="/pricing-table" className='button'>Buy Premium to View Images</Link>
                            </div>}
                            {showPhoto === "like" && <div className="image-overlay">
                            <Image onClick={()=>navigate(`/view-match/${match?.userId}`)} fluid={true} src={`${key}/images/${data?.photos[0]?.url}`} alt="photo" />
                                <Link to={`/view-match/${data?._id}`} className='button'>You need to connect with this member to View Images</Link>
                            </div>}
                            {showPhoto === "hide" && <div className="image-overlay">
                            <Image onClick={()=>navigate(`/view-match/${match?.userId}`)} fluid={true} src={`${key}/images/${data?.photos[0]?.url}`} alt="photo" />
                                <Link to={`/view-match/${data?._id}`} className='button'>Photo is Hide by the Member itself</Link>
                            </div>}
                        </div>
                        {!showBadge &&
                            <div className="image-tag">Premium <FaCrown /></div>
                        }
                    </div>
                    <div className="list-match-info">
                        <div className="match-card-header mx-auto">
                            <div className="d-flex justify-content-around">
                                <Link to={`/view-match/${data?._id}`} className="match-name">{data?.firstName} {data?.lastName} {data?.userStatus?.isVerified && <BsShieldFillCheck className='secondary' />} <span>{data?.userId}</span></Link>
                                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                                    <div className='mt-1 text-success fw-bold'><BsPeopleFill /> Chemistry</div>
                                </OverlayTrigger>
                            </div>
                            {/* <div className='d-flex justify-content-center status'>
                                <div>{match?.userStatus?.isOnline ? <HiStatusOnline className='text-success' /> : <HiStatusOnline className='text-danger' />} {match?.userStatus?.isOnline ? 'Online Now' : 'Offline'}</div>
                            </div> */}
                        </div>
                        <Col lg={12} md={12} sm={12} className="match-info backgroundLight">
                            <div className="match-card-body text-center">
                                <Row className=''>
                                    <Col>
                                        {!loading && <div>{db} yrs, {data?.personalDetails?.height}</div>}
                                        <div>{data?.personalDetails?.religion}, {data?.personalDetails?.community}</div>
                                        <div>{data?.personalDetails?.motherTongue}</div>
                                        <div>{data?.personalDetails?.residencyStatus}</div>
                                    </Col>
                                    <Col className=''>
                                        <div>{data?.personalDetails?.maritalStatus}</div>
                                        <div>{data?.personalDetails?.cityLiving}, {data?.personalDetails?.countryLiving}</div>
                                        <div>{data?.personalDetails?.bodyType}</div>
                                        <div className='badge bg-success text-white fw-bold'>Looking for: {data?.lookingFor}</div>
                                    </Col>
                                </Row>
                                <div className='match-about'>{match?.personalDetails?.aboutMe}</div>
                            </div>
                        </Col>
                    </div>
                    <div className='d-flex custom-footer-card justify-content-center'>
                        {isConnected ? <div className='list-chat-button-container d-flex-justify-content-between'>
                            <Link className='chat-now-button' to="/chat" ><BsChatHeart />Chat Now</Link>
                            <MatchContact match={data} isConnected={isConnected} />
                        </div>
                            :
                            <div className='list-connect-button-container d-flex-justify-content-between'>
                                <button className='connect-now-button' onClick={() => handleConnect(data?._id)}><FaRegCheckCircle />Connect Now</button>
                                <MatchContact match={data} isConnected={isConnected} />
                            </div>}
                    </div>
                </div>
            }
        </>
    );
}

export default MatchCard;
